import React, { useEffect } from 'react';
import Datepicker from 'react-tailwindcss-datepicker';
import './DatePicker.css';

const DatePicker = ({
  name,
  useRange = false,
  asSingle = true,
  ShowFooter = false,
  minDate,
  maxDate,
  footer,
  disabled = false,
  placement,
  className,
  placeholder,
  value,
  onChange,
  label,
  type,
  icon,
  height,
  width,
  isRequiredClass,
  isRequired,
  labelClass,
  ...props
}) => {
  const [selectedDate, setSelectedDate] = React.useState({
    startDate: null,
    endDate: null,
  });
  const [cancle, setcnacle] = React.useState(false);

  const handleChange = (e) => {
    if (!asSingle) {
      setSelectedDate({
        startDate: e.startDate,
        endDate: e.endDate,
      });
      onChange(e);
      return;
    }

    if (!e || !e.startDate) {
      // If the user clears the date, set to null
      setSelectedDate({
        startDate: null,
        endDate: null,
      });
      onChange(''); // Notify parent that the value is cleared
    } else {
      const startDate = e.startDate;
      const date = new Date(startDate);
      const dateString = date.toISOString().split('T')[0];
      setSelectedDate({
        startDate: date,
        endDate: date,
      });
      onChange(dateString); // Pass the updated value to the parent
    }
  };

  useEffect(() => {
    if (value) {
      // If a value is passed in props, use it to set the initial date
      setSelectedDate({
        startDate: value && value !== '' ? new Date(value) : null,
        endDate: value && value !== '' ? new Date(value) : null,
      });
    } else {
      setSelectedDate({
        startDate: null,
        endDate: null,
      });
      setcnacle(true);
    }
  }, [value]);

  return (
    <div className={`${width}`}>
      {/* Render label if it's passed */}
      {label && (
        <label className={labelClass}>
          {label} {isRequired && <span className={isRequiredClass}>*</span>}
        </label>
      )}

      {/* Datepicker container with dynamic width */}
      <div className={`relative flex items-center ${width}`}>
        {/* Datepicker input field */}
        <Datepicker
          disabled={disabled}
          popoverDirection={`${placement || 'up'}`}
          displayFormat="DD/MM/YYYY"
          primaryColor={'emerald'}
          footer={<button className="btn btn-primary">Apply1</button>}
          inline
          inputClassName={` border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#2D9F75]  w-full ${className}`}
          maxDate={maxDate}
          minDate={minDate}
          value={selectedDate}
          onChange={(newValue) => handleChange(newValue, false)}
          useRange={useRange}
          asSingle={asSingle}
          icon={false}
          showFooter={ShowFooter}
        />
        {icon ? (
          <div className="absolute right-4">{icon}</div>
        ) : (
          <div className="absolute right-4"></div>
        )}
      </div>
    </div>
  );
};

export default DatePicker;
// <input id={name} onClick={handleChange}

//     value={value}
//     datepicker datepicker-orientation="bottom right" type="text" class="bg-white     border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full      :ring-blue-500 :border-blue-500" placeholder="Select date" />
